module.exports = __webpack_public_path__ + "img/7c58f66.jpg";